import fp from 'lodash/fp';
import { useMemo } from 'react';


const MIN_LENGTH_SEARCH_TERM = 3;
const SEARCH_DELAY = 500;

interface SetSearchDebouncedArgs {
    func: (value?: string) => void;
    delay?: number;
    length?: number;
}

export const useSearchDebounced = ({
    func,
    delay = SEARCH_DELAY,
    length = MIN_LENGTH_SEARCH_TERM,
}: SetSearchDebouncedArgs) => useMemo(() => fp.debounce(
    delay,
    (value: string) => {
        if (value?.length >= length)
            func(value);
        else if (!value?.length)
            func();
    },
), [func, delay, length]);
